import { render, staticRenderFns } from "./Categoria.vue?vue&type=template&id=9a13bdb0&"
import script from "./Categoria.vue?vue&type=script&lang=js&"
export * from "./Categoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports